/* NEQI Hair Glossing Quiz — JS v5 (with GTM tracking) */
(function () {
  'use strict';

  var dataEl = document.getElementById('hgq-data');
  if (!dataEl) { console.error('[HGQ] no hgq-data'); return; }
  var DATA;
  try { DATA = JSON.parse(dataEl.textContent); }
  catch(e) { console.error('[HGQ] JSON error', e); return; }

  var hairTones = (DATA.hairTones||[]).sort(function(a,b){ return (a.sortOrder||99)-(b.sortOrder||99); });
  var glossings = DATA.glossings||[];
  var results   = DATA.results||[];

  // Display order for glossing tabs: Cool Blonde, Warm Blonde, Dark Brown, Light Brown
  // (independent from the fixed g1–g4 metaobject slots used for image keys)
  var TAB_DISPLAY_ORDER = ['cool-blonde','warm-blonde','dark-brown','light-brown'];
  var glossingDisplayIndices = glossings.map(function(g, i){ return i; }).sort(function(a, b){
    var ai = TAB_DISPLAY_ORDER.indexOf(glossings[a].handle);
    var bi = TAB_DISPLAY_ORDER.indexOf(glossings[b].handle);
    if (ai === -1) ai = 999 + a;
    if (bi === -1) bi = 999 + b;
    return ai - bi;
  });

  // ── German dative declension for hair tone names ───────────────
  var DATIV_MAP = {
    'schwarz':            'schwarzem',
    'sehr-dunkles-braun': 'sehr dunklem braun',
    'dunkelbraun':        'dunkelbraunem',
    'mittelbraun':        'mittelbraunem',
    'hellbraun':          'hellbraunem',
    'dunkelblond':        'dunkelblondem',
    'mittelblond':        'mittelblondem',
    'hellblond':          'hellblondem',
    'sehr-helles-blond':  'sehr hellem blond',
    'lichtblond':         'lichtblondem'
  };
  function toDativ(handle, title){
    if(DATIV_MAP[handle]) return DATIV_MAP[handle];
    if(!title) return handle;
    var n = title.trim();
    return (n.replace(/(es|e|er)?\s*$/, '') + 'em').toLowerCase();
  }

  var selTone=null, selUndertone=null, selTab=glossingDisplayIndices[0]||0, selUndertoneImg=null;
  console.log('[HGQ] tones:',hairTones.length,'glossings:',glossings.length,'results:',results.length);

  // ── Tracking ──────────────────────────────────────────────────
  function dlPush(eventName, params) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: eventName };
    if (params) {
      Object.keys(params).forEach(function(k){ payload[k] = params[k]; });
    }
    window.dataLayer.push(payload);
    console.log('[HGQ tracking]', eventName, payload);
  }

  function getQuizContext() {
    return {
      hair_tone: selTone ? selTone.handle : null,
      hair_tone_label: selTone ? selTone.title : null,
      undertone: selUndertone
    };
  }

  function saveSessionContext() {
    try {
      var filtered = getFilteredResults();
      var recommendations = filtered.length > 0 && filtered[0].recommendations ? filtered[0].recommendations : [];
      localStorage.setItem('hgq_session', JSON.stringify({
        hair_tone: selTone ? selTone.handle : null,
        hair_tone_label: selTone ? selTone.title : null,
        undertone: selUndertone,
        recommendations: recommendations,
        completed_at: new Date().toISOString(),
        expires_at: new Date(Date.now() + 2 * 60 * 60 * 1000).toISOString()
      }));
    } catch(e) {}
  }

  // ── Scroll ────────────────────────────────────────────────────
  function scrollToSection(){
    var s=document.querySelector('.hgq');
    if(!s) return;
    window.scrollTo({top:s.getBoundingClientRect().top+window.pageYOffset-16,behavior:'smooth'});
  }

  // ── Canvas ────────────────────────────────────────────────────
  function hexToRgb(h){
    h=(h||'CCA030').replace('#','');
    return{r:parseInt(h.slice(0,2),16)||0,g:parseInt(h.slice(2,4),16)||0,b:parseInt(h.slice(4,6),16)||0};
  }
  function clamp(v){return Math.max(0,Math.min(255,Math.round(v)));}
  function adjColor(hex,f){
    var c=hexToRgb(hex);
    return'rgb('+clamp(c.r+(255-c.r)*Math.max(0,f)+c.r*Math.min(0,f))+','
               +clamp(c.g+(255-c.g)*Math.max(0,f)+c.g*Math.min(0,f))+','
               +clamp(c.b+(255-c.b)*Math.max(0,f)+c.b*Math.min(0,f))+')';
  }
  var SF=[0.18,-0.05,0.10,-0.10,0.22,0,0.14,-0.08,0.06,-0.14,0.20,-0.02,0.08,-0.12,0.16,-0.06,0.12,0,0.24,-0.04];
  function drawHair(canvas,hex,w,h){
    var n=24,ctx=canvas.getContext('2d');
    canvas.width=w;canvas.height=h;
    var sw=w/n;
    for(var i=0;i<n;i++){ctx.fillStyle=adjColor(hex||'#CCA030',SF[i%SF.length]);ctx.fillRect(Math.floor(i*sw),0,Math.ceil(sw+0.5),h);}
    var g=ctx.createLinearGradient(0,0,w*0.28,0);
    g.addColorStop(0,'rgba(255,255,255,0.09)');g.addColorStop(1,'rgba(255,255,255,0)');
    ctx.fillStyle=g;ctx.fillRect(0,0,w,h);
  }

  // ── Navigate ──────────────────────────────────────────────────
  var quizStarted = false;
  function goTo(n){
    if (n < currentStep && n > 0) {
      dlPush('hgq_step_back', { from_step: currentStep, to_step: n });
    }
    currentStep = n;

    document.querySelectorAll('.hgq__screen').forEach(function(el){el.classList.remove('is-active');});
    var sc=document.getElementById('hgq-screen-'+n);
    if(sc) sc.classList.add('is-active');
    var ind=document.getElementById('hgq-step-ind');
    if(ind) ind.style.display=n===0?'none':'flex';
    if(n>0){
      document.querySelectorAll('.hgq__step-bar').forEach(function(b,i){
        b.classList.remove('is-active','is-done');
        if(i+1<n)b.classList.add('is-done');
        else if(i+1===n)b.classList.add('is-active');
      });
      var lbl=document.getElementById('hgq-step-label');
      if(lbl) lbl.textContent='0'+n+' / 03';
    }
    if(n===1 && !quizStarted){
      quizStarted=true;
      dlPush('hgq_quiz_start', {});
    }
    if(n===3){buildResults();}
    scrollToSection();
  }
  var currentStep = 0;

  // ── Step 1 ────────────────────────────────────────────────────
  function buildToneGrid(){
    var grid=document.getElementById('hgq-tone-grid');
    if(!grid) return;
    hairTones.forEach(function(tone){
      var item=document.createElement('div');item.className='hgq__tone-item';
      var lbl=document.createElement('span');lbl.className='hgq__tone-label';lbl.textContent=tone.title||tone.handle;
      var sw=document.createElement('div');sw.className='hgq__tone-swatch';
      if(tone.imageUrl){
        var img=document.createElement('img');img.src=tone.imageUrl;img.alt=tone.title||'';
        img.style.cssText='width:100%;height:100%;object-fit:cover;display:block;';sw.appendChild(img);
      } else {
        var cv=document.createElement('canvas');drawHair(cv,tone.color||'#CCA030',220,110);sw.appendChild(cv);
      }
      item.appendChild(lbl);item.appendChild(sw);
      item.addEventListener('click',(function(t,el){return function(){selectTone(t,el);};})(tone,item));
      grid.appendChild(item);
    });
  }

  function selectTone(tone,el){
    selTone=tone;
    document.querySelectorAll('.hgq__tone-item').forEach(function(i){i.classList.remove('is-selected','is-dimmed');});
    el.classList.add('is-selected');
    document.querySelectorAll('.hgq__tone-item:not(.is-selected)').forEach(function(i){i.classList.add('is-dimmed');});
    document.getElementById('hgq-btn-1').disabled=false;
    ['hgq-bc-dot-2','hgq-bc-dot-3'].forEach(function(id){var d=document.getElementById(id);if(d&&tone.color)d.style.background=tone.color;});
    ['hgq-bc-tone-2','hgq-bc-tone-3'].forEach(function(id){var d=document.getElementById(id);if(d)d.textContent=tone.title||tone.handle;});
    var coolDescEl=document.getElementById('hgq-cool-desc');
    var warmDescEl=document.getElementById('hgq-warm-desc');
    if(coolDescEl) coolDescEl.textContent=tone.coolText&&tone.coolText.length>0?tone.coolText:(DATA.fallbackCoolDesc||(tone.title+' · kühl'));
    if(warmDescEl) warmDescEl.textContent=tone.warmText&&tone.warmText.length>0?tone.warmText:(DATA.fallbackWarmDesc||(tone.title+' · warm'));
    updateUndertoneImages(tone);

    dlPush('hgq_tone_selected', {
      hair_tone: tone.handle,
      hair_tone_label: tone.title || tone.handle
    });
  }

  // ── Step 2 ────────────────────────────────────────────────────
  function updateUndertoneImages(tone){
    function set(elId,url){
      var el=document.getElementById(elId);if(!el)return;
      if(url){el.innerHTML='<img src="'+url+'" style="width:100%;height:100%;object-fit:cover;display:block;">';}
      else{var cv=document.createElement('canvas');drawHair(cv,tone.color||'#CCA030',600,200);el.innerHTML='';el.appendChild(cv);}
    }
    set('hgq-undertone-cool-img',tone.coolImageUrl);
    set('hgq-undertone-warm-img',tone.warmImageUrl);
  }

  function selectUndertone(val){
    selUndertone=val;
    selUndertoneImg=selTone?(val==='cool'?(selTone.coolImageUrl||selTone.imageUrl):(selTone.warmImageUrl||selTone.imageUrl)):null;
    document.getElementById('hgq-card-cool').classList.toggle('is-selected',val==='cool');
    document.getElementById('hgq-card-warm').classList.toggle('is-selected',val==='warm');
    document.getElementById('hgq-card-cool').classList.toggle('is-dimmed',val==='warm');
    document.getElementById('hgq-card-warm').classList.toggle('is-dimmed',val==='cool');
    var el=document.getElementById('hgq-bc-temp');if(el)el.textContent=val==='cool'?'Kühl':'Warm';

    dlPush('hgq_undertone_selected', {
      hair_tone: selTone ? selTone.handle : null,
      hair_tone_label: selTone ? selTone.title : null,
      undertone: val
    });

    setTimeout(function(){
      var filtered = getFilteredResults();
      var recommendations = filtered.length > 0 && filtered[0].recommendations ? filtered[0].recommendations : [];
      dlPush('hgq_quiz_complete', {
        hair_tone: selTone ? selTone.handle : null,
        hair_tone_label: selTone ? selTone.title : null,
        undertone: val,
        recommended_glossings: recommendations.join(',')
      });
      saveSessionContext();

      // Cart Attributes beim Quiz-Abschluss setzen — damit auch Käufe über die
      // Produktseite getrackt werden (nicht nur über den Quiz-Warenkorb-Button)
      var filteredForAttrs = getFilteredResults();
      var recsForAttrs = filteredForAttrs.length > 0 && filteredForAttrs[0].recommendations ? filteredForAttrs[0].recommendations : [];
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          attributes: {
            hgq_hair_tone: selTone ? selTone.handle : '',
            hgq_hair_tone_label: selTone ? selTone.title : '',
            hgq_undertone: val,
            hgq_recommendations: recsForAttrs.join(','),
            hgq_glossing: '',
            hgq_glossing_label: '',
            hgq_variant_id: '',
            hgq_timestamp: new Date().toISOString()
          }
        })
      }).catch(function(){});

      if(recommendations.length > 0){
        var firstRecIdx = glossingDisplayIndices.find(function(i){
          return recommendations.indexOf(glossings[i].handle) !== -1;
        });
        selTab = (firstRecIdx !== undefined) ? firstRecIdx : glossingDisplayIndices[0];
      } else {
        selTab = glossingDisplayIndices[0];
      }
      goTo(3);
    },320);
  }

  // ── Step 3 helpers ────────────────────────────────────────────
  function norm(s){return(s||'').toString().toLowerCase().trim();}

  function getFilteredResults(){
    if(!selTone||!selUndertone)return[];
    var f=results.filter(function(r){
      return norm(r.hairToneHandle)===norm(selTone.handle)&&norm(r.undertone)===norm(selUndertone);
    });
    console.log('[HGQ] filtered:',f.length,'for',selTone.handle,selUndertone);
    return f;
  }

  // ── Build tabs ────────────────────────────────────────────────
  function buildGlossingTabs(){
    var tabEl=document.getElementById('hgq-glossing-tabs');
    if(!tabEl)return;
    tabEl.innerHTML='';

    var filtered=getFilteredResults();
    var recommendations=filtered.length>0&&filtered[0].recommendations?filtered[0].recommendations:[];

    var indicesToShow = glossingDisplayIndices;
    if(DATA.onlyRecommended && recommendations.length > 0){
      var recIndices = glossingDisplayIndices.filter(function(i){
        return recommendations.indexOf(glossings[i].handle) !== -1;
      });
      if(recIndices.length > 0) indicesToShow = recIndices;
    }

    if(indicesToShow.indexOf(selTab) === -1){
      selTab = indicesToShow[0];
    }

    indicesToShow.forEach(function(idx){
      var gl=glossings[idx];
      var isRecommended=recommendations.indexOf(gl.handle)!==-1;
      var btn=document.createElement('button');
      var showRecLabel = isRecommended;
      btn.className='hgq__gtab'+(idx===selTab?' is-active':'')+(isRecommended?' is-recommended':'');
      if(showRecLabel){
        btn.innerHTML='<span class="hgq__gtab-rec">Empfohlen</span><span class="hgq__gtab-title">'+gl.title+'</span>';
      } else {
        btn.innerHTML='<span class="hgq__gtab-title">'+gl.title+'</span>';
      }
      btn.addEventListener('click',(function(i, g){return function(){
        selTab=i;
        document.querySelectorAll('.hgq__gtab').forEach(function(t){t.classList.remove('is-active');});
        btn.classList.add('is-active');
        dlPush('hgq_glossing_tab_view', {
          glossing: g.handle,
          glossing_label: g.title,
          hair_tone: selTone ? selTone.handle : null,
          undertone: selUndertone,
          is_recommended: recommendations.indexOf(g.handle) !== -1
        });
        renderTabContent();
      };})(idx, gl));
      tabEl.appendChild(btn);
    });
  }

  // ── Render tab content ────────────────────────────────────────
  function renderTabContent(){
    var container=document.getElementById('hgq-result-container');
    if(!container)return;
    container.innerHTML='';

    var filtered=getFilteredResults();
    var gl=glossings[selTab];
    if(!gl){console.warn('[HGQ] no glossing at tab',selTab);return;}

    var result=filtered.length>0?filtered[0]:null;
    var gKey='g'+(selTab+1);
    console.log('[HGQ] tab',selTab,'glossing:',gl.handle,'gKey:',gKey,'result:',result?'found':'null');

    var tabLayout=document.createElement('div');tabLayout.className='hgq__tab-layout';

    [{t:'3',k:'3min'},{t:'5',k:'5min'},{t:'10',k:'10min'}].forEach(function(time){
      var imgKey=gKey+'_'+time.k;
      var imgUrl=result&&result[imgKey]?result[imgKey]:null;
      var card=document.createElement('div');card.className='hgq__rc';
      var hair=document.createElement('div');hair.className='hgq__rc-hair';
      if(imgUrl){
        hair.innerHTML='<img src="'+imgUrl+'" alt="'+time.t+' Min" style="width:100%;height:100%;object-fit:cover;display:block;">';
      } else if(selUndertoneImg){
        hair.innerHTML='<img src="'+selUndertoneImg+'" alt="'+time.t+' Min" style="width:100%;height:100%;object-fit:cover;display:block;">';
      } else {
        var cv=document.createElement('canvas');drawHair(cv,gl.color||'#CCA030',300,110);hair.appendChild(cv);
      }
      var body=document.createElement('div');body.className='hgq__rc-body';
      body.innerHTML='<div class="hgq__rc-time">Einwirkzeit '+time.t+' Min</div>';
      card.appendChild(hair);card.appendChild(body);
      tabLayout.appendChild(card);
    });

    // Product card
    var pc=document.createElement('div');pc.className='hgq__product-card';
    var variantId=gl.variantId?parseInt(gl.variantId,10):null;
    var productTitle=gl.productTitle||gl.title;
    var pcImg=gl.productImage?'<div class="hgq__product-img"><img src="'+gl.productImage+'" alt="'+productTitle+'"></div>':'';
    var stars='';
    if(gl.productRating){
      var rn=parseFloat(gl.productRating),str='';
      for(var s=0;s<5;s++)str+=s<Math.floor(rn)?'★':'☆';
      stars='<div class="hgq__product-rating">'+str+(gl.reviewCount?' <span>('+gl.reviewCount+')</span>':'')+'</div>';
    }
    var productBtn=gl.productUrl?'<a href="'+gl.productUrl+'" target="_blank" class="hgq__btn-product">Zum Produkt</a>':'';
    var cartBtn=variantId?'<button class="hgq__btn-cart" data-variant="'+variantId+'">In den Warenkorb</button>':'<button class="hgq__btn-cart" disabled>Bald wieder erhältlich</button>';
    pc.innerHTML=pcImg+'<div class="hgq__product-info"><div class="hgq__product-title">'+productTitle+'</div>'+(gl.productPrice?'<div class="hgq__product-price">'+gl.productPrice+'</div>':'')+stars+'<div class="hgq__product-buttons">'+productBtn+cartBtn+'</div></div>';

    // Track "Zum Produkt" clicks
    var productLinkEl = pc.querySelector('.hgq__btn-product');
    if(productLinkEl) productLinkEl.addEventListener('click', (function(g, pt){return function(){
      dlPush('hgq_product_link_click', Object.assign({}, getQuizContext(), {
        glossing: g.handle,
        glossing_label: g.title,
        product_title: pt
      }));
    };})(gl, productTitle));

    // Wire cart button
    var cartEl=pc.querySelector('[data-variant]');
    if(cartEl)cartEl.addEventListener('click',(function(vid,btn,g,pt){return function(){
      addToCart(vid,btn,g,pt);
    };})(variantId,cartEl,gl,productTitle));

    tabLayout.appendChild(pc);
    container.appendChild(tabLayout);

    // Back button nach Ergebniskarten, vor Anwendung
    var backNav = document.createElement('div');
    backNav.className = 'hgq__nav';
    backNav.style.marginTop = '1.5rem';
    var backBtn = document.createElement('button');
    backBtn.className = 'hgq__btn-back';
    backBtn.innerHTML = '&larr; Zurück';
    backBtn.addEventListener('click', function(){ goTo(2); });
    backNav.appendChild(backBtn);
    container.appendChild(backNav);

    // Anwendung
    var anw=document.createElement('div');anw.className='hgq__anwendung';
    var steps=DATA.anwendungSteps||['Haare shampoonieren, leicht ausdrücken.','Glossing Mask auftragen, gleichmäßig verteilen und einmassieren. Handschuhe empfohlen.','Mindestens 3 Minuten einwirken lassen, für intensiveres Ergebnis bis zu 10 Minuten.','Gründlich ausspülen und die Haare mit einem Conditioner versiegeln.'];
    var stepsHtml=steps.map(function(txt,i){return '<div class="hgq__anw-step"><span class="hgq__anw-num">0'+(i+1)+'</span><span class="hgq__anw-text">'+txt+'</span></div>';}).join('');
    var videoHtml='<span class="hgq__video-placeholder">Anwendungsvideo</span>';
    if(gl.videoDesktop||gl.videoMobile){
      var deskSrc=gl.videoDesktop?'<source src="'+gl.videoDesktop+'" type="video/mp4">':'';
      var mobSrc=gl.videoMobile?'<source src="'+gl.videoMobile+'" type="video/mp4">':'';
      videoHtml='<div class="hgq__video-player">'
        +'<div class="hgq__video-desktop"><video class="hgq__video-el" autoplay muted loop playsinline style="width:100%;height:100%;object-fit:cover;display:block;">'+deskSrc+'</video></div>'
        +(gl.videoMobile?'<div class="hgq__video-mobile"><video class="hgq__video-el" autoplay muted loop playsinline style="width:100%;height:100%;object-fit:cover;display:block;">'+mobSrc+'</video></div>':'')
        +'<div class="hgq__video-controls">'
          +'<button class="hgq__vc-btn hgq__vc-play" title="Play/Pause">'
            +'<svg class="hgq__vc-icon-play" viewBox="0 0 24 24" fill="currentColor"><polygon points="5,3 19,12 5,21"/></svg>'
            +'<svg class="hgq__vc-icon-pause" viewBox="0 0 24 24" fill="currentColor" style="display:none"><rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/></svg>'
          +'</button>'
          +'<button class="hgq__vc-btn hgq__vc-mute" title="Mute/Unmute">'
            +'<svg class="hgq__vc-icon-mute" viewBox="0 0 24 24" fill="currentColor"><path d="M11 5L6 9H2v6h4l5 4V5z"/><line x1="23" y1="9" x2="17" y2="15" stroke="currentColor" stroke-width="2"/><line x1="17" y1="9" x2="23" y2="15" stroke="currentColor" stroke-width="2"/></svg>'
            +'<svg class="hgq__vc-icon-unmute" viewBox="0 0 24 24" fill="currentColor" style="display:none"><path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07" stroke="currentColor" stroke-width="2" fill="none"/></svg>'
          +'</button>'
        +'</div>'
      +'</div>';
    }
    anw.innerHTML='<h2 class="hgq__anw-title">Anwendung</h2><div class="hgq__anw-inner"><div class="hgq__anw-steps">'+stepsHtml+'</div><div class="hgq__video-wrap">'+videoHtml+'</div></div>';
    container.appendChild(anw);

    // Wire up video controls
    var player=container.querySelector('.hgq__video-player');
    if(player){
      var vids=player.querySelectorAll('.hgq__video-el');
      var playBtn=player.querySelector('.hgq__vc-play');
      var muteBtn=player.querySelector('.hgq__vc-mute');
      function syncPlayIcons(paused){
        if(!playBtn)return;
        playBtn.querySelector('.hgq__vc-icon-play').style.display=paused?'':'none';
        playBtn.querySelector('.hgq__vc-icon-pause').style.display=paused?'none':'';
      }
      function syncMuteIcons(muted){
        if(!muteBtn)return;
        muteBtn.querySelector('.hgq__vc-icon-mute').style.display=muted?'':'none';
        muteBtn.querySelector('.hgq__vc-icon-unmute').style.display=muted?'none':'';
      }
      syncPlayIcons(false);
      syncMuteIcons(true);
      if(playBtn) playBtn.addEventListener('click',function(){
        vids.forEach(function(v){v.paused?v.play():v.pause();});
        syncPlayIcons(vids[0]&&vids[0].paused);
      });
      if(muteBtn) muteBtn.addEventListener('click',function(){
        var nowMuted=vids[0]&&vids[0].muted;
        vids.forEach(function(v){v.muted=!nowMuted;});
        syncMuteIcons(!nowMuted);
      });
    }
  }

  function buildResults(){
    var introEl=document.getElementById('hgq-result-intro');
    if(introEl&&selTone&&selUndertone){
      var filtered=getFilteredResults();
      var recommendations=filtered.length>0&&filtered[0].recommendations?filtered[0].recommendations:[];
      var recGlossings=glossings.filter(function(g){return recommendations.indexOf(g.handle)!==-1;});
      var names=(recGlossings.length>0?recGlossings:glossings.slice(0,2)).map(function(g){return'<strong>'+g.title+'</strong>';}).join(' oder ');
      var dativ=toDativ(selTone.handle, selTone.title);
      var temp=selUndertone==='cool'?'kühlem':'warmem';
      introEl.innerHTML='Bei <strong>'+dativ+'</strong> Haar und einem <strong>'+temp+'</strong> Unterton empfehlen wir dir die NEQI Glossing Mask '+names+'.';
    }
    var descEl=document.getElementById('hgq-result-desc');
    if(descEl) descEl.textContent=DATA.resultDesc||'So verändert das Glossing deinen Farbton, je nach Einwirkzeit.';
    buildGlossingTabs();
    renderTabContent();
  }

  // ── Add to Cart ───────────────────────────────────────────────
  function addToCart(variantId, btnEl, gl, productTitle){
    if(!variantId){console.warn('[HGQ] addToCart: no variantId');return;}
    console.log('[HGQ] addToCart variantId:',variantId);
    if(btnEl){btnEl.disabled=true;btnEl.textContent='...';}

    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:variantId,quantity:1})
    })
    .then(function(r){
      if(!r.ok){return r.text().then(function(t){console.error('[HGQ] cart error:',t);throw new Error(t);});}
      return r.json();
    })
    .then(function(d){
      console.log('[HGQ] cart add success',d);
      if(btnEl){btnEl.textContent='✓ Hinzugefügt';setTimeout(function(){btnEl.disabled=false;btnEl.textContent='In den Warenkorb';},2000);}

      // Track add to cart
      dlPush('hgq_add_to_cart', Object.assign({}, getQuizContext(), {
        glossing: gl ? gl.handle : null,
        glossing_label: gl ? gl.title : null,
        product_title: productTitle || null,
        variant_id: variantId,
        quiz_context: true
      }));

      // Cart Attributes beim Add-to-Cart überschreiben mit Glossing-Details
      var filtered = getFilteredResults();
      var recommendations = filtered.length > 0 && filtered[0].recommendations ? filtered[0].recommendations : [];
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          attributes: {
            hgq_hair_tone: selTone ? selTone.handle : '',
            hgq_hair_tone_label: selTone ? selTone.title : '',
            hgq_undertone: selUndertone || '',
            hgq_recommendations: recommendations.join(','),
            hgq_glossing: gl ? gl.handle : '',
            hgq_glossing_label: gl ? gl.title : '',
            hgq_variant_id: variantId ? String(variantId) : '',
            hgq_timestamp: new Date().toISOString()
          }
        })
      }).catch(function(e){ console.warn('[HGQ] cart attributes update failed:', e); });

      updateCartAndOpenDrawer();
    })
    .catch(function(e){
      console.error('[HGQ] addToCart failed:',e);
      if(btnEl){btnEl.disabled=false;btnEl.textContent='Fehler – erneut versuchen';}
    });
  }

  function updateCartAndOpenDrawer(){
    fetch('/?sections=cart-counter,cart-drawer')
    .then(function(r){return r.json();})
    .then(function(data){
      if(data['cart-counter']){
        var counterEl=document.querySelector('#cart-counter');
        if(counterEl){
          var parser=new DOMParser();
          var doc=parser.parseFromString(data['cart-counter'],'text/html');
          var newCounter=doc.querySelector('#shopify-section-cart-counter');
          if(newCounter) counterEl.innerHTML=newCounter.innerHTML;
        }
      }
      if(data['cart-drawer']){
        var drawerBody=document.querySelector('#CartDrawer-Body');
        if(drawerBody){
          var parser2=new DOMParser();
          var doc2=parser2.parseFromString(data['cart-drawer'],'text/html');
          var newBody=doc2.querySelector('#shopify-section-cart-drawer #CartDrawer-Body');
          if(newBody) drawerBody.innerHTML=newBody.innerHTML;
        }
      }
      var drawer=document.querySelector('cart-drawer');
      if(drawer&&typeof drawer.open==='function'){
        drawer.open();
      } else {
        var cartLink=document.querySelector('[data-cart-link]');
        if(cartLink) cartLink.click();
      }
    })
    .catch(function(e){
      console.error('[HGQ] cart update failed:',e);
    });
  }

  // ── Init ──────────────────────────────────────────────────────
  function init(){
    buildToneGrid();
    var $=function(id){return document.getElementById(id);};
    $('hgq-btn-start')&&$('hgq-btn-start').addEventListener('click',function(){goTo(1);});
    $('hgq-btn-1')&&$('hgq-btn-1').addEventListener('click',function(){goTo(2);});
    $('hgq-btn-back-2')&&$('hgq-btn-back-2').addEventListener('click',function(){goTo(1);});
    $('hgq-card-cool')&&$('hgq-card-cool').addEventListener('click',function(){selectUndertone('cool');});
    $('hgq-card-warm')&&$('hgq-card-warm').addEventListener('click',function(){selectUndertone('warm');});
    $('hgq-restart')&&$('hgq-restart').addEventListener('click',function(){
      selTone=null;selUndertone=null;selTab=glossingDisplayIndices[0]||0;selUndertoneImg=null;quizStarted=false;currentStep=0;
      document.querySelectorAll('.hgq__tone-item').forEach(function(i){i.classList.remove('is-selected','is-dimmed');});
      $('hgq-card-cool').classList.remove('is-selected','is-dimmed');
      $('hgq-card-warm').classList.remove('is-selected','is-dimmed');
      $('hgq-btn-1').disabled=true;
      dlPush('hgq_quiz_restart', {});
      goTo(0);
    });
    var section=document.querySelector('.hgq');
    if(section){
      section.addEventListener('click',function(e){
        var btn=e.target.closest('.hgq__bundle [data-variant]');
        if(btn){
          var vid=parseInt(btn.getAttribute('data-variant'),10);
          var title=btn.closest('.hgq__product-card') ? (btn.closest('.hgq__product-card').querySelector('.hgq__product-title')||{}).textContent : null;
          addToCart(vid,btn,null,title);
        }
      });
    }
    if(hairTones.length)updateUndertoneImages(hairTones[Math.floor(hairTones.length/2)]);
    console.log('[HGQ] ready');
  }

  document.readyState==='loading'?document.addEventListener('DOMContentLoaded',init):init();
})();